// extracted by mini-css-extract-plugin
module.exports = {"bold-info":"Meal_bold-info__3aKaa","divider":"Meal_divider__LdMhQ"};